<template>
  <div class="container">
    <ReturnBtn
      blackColor
      :path="returnPath ? returnPath : `subskrypcja`"
    ></ReturnBtn>
    <div class="section-title" style="text-align:center; margin-top:50px;">
      subskrypcje
    </div>
 
    <div class="packages">
      <Package
        :pack="timePackage"
        :firstElement="index === 0"
        :lastElement="index === timePackages.length - 1"
        v-for="(timePackage, index) in timePackages"
        :key="timePackage.id"
        :timePackagesItemsNames="timePackagesItemsNames"
        :basicPrice="timePackages[0] ? timePackages[0].price : null"
      />
    </div>
    <DescriptionCard title="Co w ramach subskrypcji?">
      <template slot="content">
        <p class="text-center description">
          Wykupując subskrypcję, otrzymujesz pełen dostęp do wszystkich grup
          praktyk:
          <span class="font-weight-medium"
            >praktyki docelowe, uzupełniające, praktyki dla początkujących,
            analiza asan, oddech i medytacja.</span
          >
        </p>
        <p class="text-center description">
          <span class="font-weight-medium">Każdego miesiąca</span> są dodawane
          dwie <span class="font-weight-medium">nowe praktyki</span>, jedna na
          początku miesiąca, druga w połowie. Praktyki są pełnowartościowe, z
          jasnym przekazem. Sekwencje zawierają również modyfikacje
          trudniejszych asan, które możesz dostosować do swojego poziomu i
          samopoczucia.
        </p>
        <p class="text-center description">
          Praktyki są ułożone z dbałością o szczegóły,
          <span class="font-weight-medium"
            >oparte o wiedzę anatomiczną, równoważą układ współczuły oraz
            przywspółczulny</span
          >, dzięki czemu dają sto procent rezultatów na poziomie ciała oraz
          umysłu.
        </p>
      </template>
    </DescriptionCard>
  </div>
</template>

<script>
import Package from "../components/Package.vue";
import DescriptionCard from "../components/DescriptionCard.vue";
import ReturnBtn from "../components/ReturnBtn.vue";

export default {
  metaInfo: {
    title: "Dagajoga subskrypcja - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "TimeSubscriptions",
  components: {
    Package,
    DescriptionCard,
    ReturnBtn
  },
  data: () => ({
    returnPath: "",
  }),
  methods: {},
  async created() {
    if (this.$route.params.returnPath) {
      this.returnPath = this.$route.params.returnPath;
    }
    await this.$store.dispatch(`auth/checkUserActiveSubscriptions`);
    if (this.hasActiveSubscription) {
      await this.$store.dispatch(`timePackages/fetchActiveSubscriptions`);
    } else {
      await this.$store.dispatch(`timePackages/setActiveSubscriptionsToNull`);
    }
    this.$store.dispatch("timePackages/fetchAllTimePackages");
    this.$store.dispatch("timePackages/fetchAllTimePackagesItemsNames");
  },
  computed: {
    timePackages() {
      return this.$store.getters["timePackages/getAllTimePackages"];
    },
    timePackagesItemsNames() {
      return this.$store.getters["timePackages/getAllTimePackagesItemsNames"];
    },
  },
};
</script>

<style scoped>
.description {
  font-size: 20px;
  padding: 12px;
}
.container {
  height: 100%;
  min-width: 100%;
  margin: 0;
  padding: 0;
  z-index: 100;
}
.header-image {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 400px;
}
.header-image img {
  width: inherit;
  /* height: 100%; */
  max-width: 640px;
  padding-top: 3rem;
}

.packages {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  margin: 2rem 3rem;
  overflow: hidden;
  gap: 50px;
}

@media screen and (max-width: 1300px) {
  .packages {
    top: 300px;
    flex: wrap;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 1050px) {
  .packages {
    top: 250px;
  }
}
@media screen and (max-width: 1150px) {
  .packages {
    /* flex-direction: column; */
    flex: wrap;
    flex-wrap: wrap;
    top: 200px;
  }
}
@media screen and (max-width: 500px) {
  .header img {
    height: 300px;
    width: fit-content;
    object-fit: cover;
  }
}
</style>
